import { Model } from "../model";
import type { Scenario } from "../types";

export interface ValidationResult {
  valid: boolean;
  errors: Array<{ path: string; message: string }>;
}

export function validateScenario(scenario: unknown): ValidationResult {
  try {
    const s = scenario as Scenario;
    const errors = Model.validate(s);
    return { valid: errors.length === 0, errors };
  } catch (e) {
    return { valid: false, errors: [{ path: "root", message: String(e) }] };
  }
}
